import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export type getAllStationAQIDataEMISResponse = {
  data: any[];
  status: boolean;
  message: string;
};

export const getAllStationAQIDataEMIS = async (): Promise<
  AxiosResponse<getAllStationAQIDataEMISResponse>
> => {
  const config: AxiosRequestConfig = {
    method: "get",
    url: "http://emis.wbpcb.gov.in/airquality/allstndata",
  };
  console.log("Fetching AQI data");
  const response: AxiosResponse<getAllStationAQIDataEMISResponse> = await axios(
    config
  )
    .then((r: any) => {
      console.log("AQI data from EMIS received");
      return r;
    })
    .catch((err: any) => {
      console.log("error while getting AQI data from EMIS");
      return err.response;
    });

  return response;
};
